query listTeamsInTeamListPage(
  $search: [String]
  $typeFilters: [String]
  $includeEmptyGroups: Boolean
  $includeTotalCount: Boolean
  $limit: Int
  $offset: Int
) {
  result: listGroups(
    search: $search
    groupTypes: $typeFilters
    includeEmptyGroups: $includeEmptyGroups
    includeTotalCount: $includeTotalCount
    limit: $limit
    offset: $offset
    includeHiddenGroups: false
  ) {
    totalCount
    hasMore
    groups {
      id
      type
      hierarchy
      name
      parentIds
      attributes {
        id
        attributeType
        subtype
        value
        label
      }
    }
  }
}

query listTeamsForGoalsExplore(
  $search: [String]
  $typeFilters: [String]
  $includeEmptyGroups: Boolean
  $includeTotalCount: Boolean
  $limit: Int
  $offset: Int
) {
  result: listGroups(
    search: $search
    groupTypes: $typeFilters
    includeEmptyGroups: $includeEmptyGroups
    includeTotalCount: $includeTotalCount
    limit: $limit
    offset: $offset
    includeHiddenGroups: false
  ) {
    totalCount
    hasMore
    groups {
      id
      type
      hierarchy
      name
      objectiveIds
      attributes {
        id
        attributeType
        subtype
        value
        label
      }
    }
  }
}

query listTeamTypesInTeamListPage(
  $search: [String]
  $includeEmptyGroups: Boolean
) {
  types: listGroupTypes(
    search: $search
    includeEmptyGroups: $includeEmptyGroups
    includeHiddenGroups: false
  ) {
    key
    term
    count
  }
}
